export const MESSAGE_FROM = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
};

export const MESSAGE_TYPE = {
  text: 'text',
  cards: 'cards',
  action: 'action',
};

export const CARD_TYPE = {
  image: 'image',
  button: 'button',
};

export const ACTION_TYPE = {
  requestBodyScan: 'request_body_scan',
  vtoSourceImageUploaded: 'vto_source_image_uploaded',
  requestVtoSourceImage: 'request_vto_source_image',
  na: 'na',
  explainBodyShape: 'explain_body_shape',
  vto: 'vto',
};

export const BODY_AI_SCANNER_PAYLOAD = {
  name: 'TG3D Office',
  type: 'mobile',
  provider: 10,
  id: 'V3XAKZP',
  key: 'n1xBLdwy88UjsaNp2QQZ4veiqx4Z7drBvNIt',
  token: 'yiyCANL_C2StyVefzTLsHRHgz6u5XAxpAvGZSAqxq_wU_C3P9YuxWwrvfQ8RLXLE',
};

export const BODY_SHAPE = {
  'Inverted Triangle': 'inverted_triangle',
  Triangle: 'triangle',
  Trapezoid: 'trapezoid',
  Rectangle: 'rectangle',
  Oval: 'oval',
  Pear: 'pear',
  Hourglass: 'hourglass',
  Apple: 'apple',
  Unknown: 'unknown',
};
